import React from 'react';
import { VISIBILITY_OPTIONS } from './vaultConstants';

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

export const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });

export const getTimeRemaining = (autoGrantAt) => {
  const now = new Date();
  const deadline = new Date(autoGrantAt);
  const diff = deadline - now;
  if (diff <= 0) return 'Auto-granting soon...';
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  if (hours > 24) return `${Math.floor(hours / 24)}d ${hours % 24}h remaining`;
  if (hours > 0) return `${hours}h ${minutes}m remaining`;
  return `${minutes}m remaining`;
};

export const getVisibilityBadge = (visibility) => {
  const option = VISIBILITY_OPTIONS.find(o => o.value === visibility) || VISIBILITY_OPTIONS[1];
  const Icon = option.icon;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${option.color}`}>
      <Icon className="w-3 h-3" />
      {option.label}
    </span>
  );
};
